import { render, staticRenderFns } from "./orderRankList.vue?vue&type=template&id=4c070f63&scoped=true&"
import script from "./orderRankList.vue?vue&type=script&lang=js&"
export * from "./orderRankList.vue?vue&type=script&lang=js&"
import style0 from "./orderRankList.vue?vue&type=style&index=0&id=4c070f63&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c070f63",
  null
  
)

export default component.exports